

















import { isWindowSize } from '@getaccept/lib-shared/src/helpers/window-size.helper';
import { WindowSize } from '@getaccept/lib-shared/src/enums/window-size';
import { computed, defineComponent, onMounted, ref } from '@vue/composition-api';
import { AfterSignStep } from '../../../types/enums/after-sign-step';
import { isPopupBlocked } from '../../../../common/utils/window';

export default defineComponent({
  props: {
    redirectUrl: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const isSmallScreen = ref(isWindowSize(WindowSize.XSmall));
    const url = ref('');
    const popupBlocked = ref(false);
    const redirectTimeout = 3000;

    const handleClose = () => {
      emit('close');
    };

    const showLoader = computed(() => isSmallScreen.value && !popupBlocked.value);

    onMounted(() => {
      if (!isSmallScreen.value) {
        const { href, pathname } = window.location;
        url.value = href.replace(pathname, `/${props.redirectUrl}`);

        setTimeout(() => {
          const newWindow: Window = window.open(url.value, '_blank');
          popupBlocked.value = isPopupBlocked(newWindow);
        }, redirectTimeout);
      }
    });

    return {
      isSmallScreen,
      url,
      popupBlocked,
      handleClose,
      showLoader,
      AfterSignStep,
    };
  },
});
